<div class="app-dialog-confirm-buttons flex justify-center">
  <lib-button weight="secondary" class="app-cancel-button" (click)="cancel.emit()">
    {{ cancelText }}
  </lib-button>

  <lib-button
    weight="primary"
    class="app-confirm-button"
    [disabled]="!canConfirm"
    (click)="confirm.emit()"
  >
    {{ confirmText }}
  </lib-button>
</div>
